import React, { useEffect, useState } from 'react';
import { URL } from '../variables';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../Header';
import Aside from '../SideBar/Aside';

import '../SideBar/styles/App.scss'; 
import { mudarDados } from '../actions/AppActions';
import { Route, Switch } from 'react-router-dom';
import { can, canManageMembers, canSeeRooms, unrestricted } from '../permissions';

import Request from '../Request';
import GlobalBreadcrumb from './ReusableComponents/GlobalBreadcrumb';
import Faculdades from './Faculdades/Faculdades';
import CriarFaculdade from './Faculdades/CriarFaculdade';
import EditarFaculdade from './Faculdades/EditarFaculdade';
import ShowFaculdade from './Faculdades/ShowFaculdade';
import MinhaOrganizadora from './MinhaOrganizadora/MinhaOrganizadora';
import EditOrganization from './MinhaOrganizadora/EditOrganization';
import {PortalHome,PortalSelection,PortalApplications,PortalApplication} from './PortalAluno';
import CriarProcesso from './Processo/CriarProcesso';
import EditarProcesso from './Processo/EditarProcesso';
import CriarCorretor from './Corretores/CriarCorretor';
import EditarCorretor from './Corretores/EditarCorretor';
import CriarFiscal from './Fiscais/CriarFiscal';
import EditarFiscal from './Fiscais/EditarFiscal';
import CriarAluno from './Alunos/CriarAluno';
import EditarAluno from './Alunos/EditarAluno';
import CategoriasQuestoes from './CategoriasQuestoes/CategoriasQuestoes';
import CriarCategoria from './CategoriasQuestoes/CriarCategoria';
import EditarCategoria from './CategoriasQuestoes/EditarCategoria';
import Questoes from './CategoriasQuestoes/Questoes';
import CriarQuestao from './CategoriasQuestoes/CriarQuestao';
import EditarQuestao from './CategoriasQuestoes/EditarQuestao';
import ChatBotQuestao from './CategoriasQuestoes/ChatBotQuestao';

import BancaQuestoes from './BancaQuestoes/BancaQuestoes';

import ShowProcesso from './Processo/ShowProcesso';
import CriarRedacao from './Redacoes/CriarRedacao';
import EditarRedacao from './Redacoes/EditarRedacao';
import CriarProva from './Provas/CriarProva';
import EditarProva from './Provas/EditarProva';
import CriarCandidatoVinculado from './CandidatosVinculados/CriarCandidatoVinculado';
import CriarFiscalVinculado from './FiscaisVinculados/CriarFiscalVinculado';
import CriarCorretorVinculado from './CorretoresVinculados/CriarCorretorVinculado';
import ShowSala from './SalasProcesso/ShowSala';
import ShowRedacoesProcesso from './RedacoesProcesso/ShowRedacoesProcesso';
import ShowProvasProcesso from './ProvasProcesso/ShowProvasProcesso';
import ShowCandidato from './CandidatosVinculados/ShowCandidato';
import ShowFiscal from './FiscaisVinculados/ShowFiscal';
import ShowAvaliador from './AvaliadoresVinculados/ShowAvaliador';
import EditarCandidatoConflito from './CandidatosConflitos/EditarCandidatoConflito';
import ShowAnalise from './AnalisesCandidatos/ShowAnalise';
import CriarProvaExistente from './Provas/CriarProvaExistente';

import DashboardInstituicao from './Faculdades/Dashboard';
import Questionarios from './Questionarios/Questionarios';
import CriarQuestionario from './Questionarios/CriarQuestionario';
import EditarQuestionario from './Questionarios/EditarQuestionario';
import CriarQuestionarioVinculado from './QuestionariosVinculados/CriarQuestionarioVinculado';
import ShowQuestionarioProcesso from './QuestionariosVinculados/ShowQuestionarioProcesso';
import Professores from './Professores/Professores';
import CriarProfessor from './Professores/CriarProfessor';
import EditarProfessor from './Professores/EditarProfessor';
import Demandas from './Demandas/Demandas';
import CriarDemanda from './Demandas/CriarDemanda';
import EditarDemanda from './Demandas/EditarDemanda';
import ShowDemanda from './Demandas/ShowDemanda';

import Conteudos from './Conteudos/Conteudos';
import CriarConteudo from './Conteudos/CriarConteudo';
import EditarConteudo from './Conteudos/EditarConteudo';
import ShowConteudo from './Conteudos/ShowConteudo';
import CriarQuestaoConteudo from './Conteudos/CriarQuestaoConteudo';
import EditarQuestaoConteudo from './Conteudos/EditarQuestaoConteudo';

import CriarAtribuicoes from './Demandas/CriarAtribuicoes';
import Recursos from './Recursos/Recursos';
import CriarRecurso from './Recursos/CriarRecurso';
import EditarRecurso from './Recursos/EditarRecurso';
import ShowRecurso from './Recursos/ShowRecurso';
import QuestoesDemanda from './Demandas/QuestoesDemanda';
import CriarDiagramacao from './Diagramacoes/CriarDiagramacao';
import EditarDiagramacao from './Diagramacoes/EditarDiagramacao';
import Clientes from './Clientes/Clientes';
import CriarCliente from './Clientes/CriarCliente';
import EditarCliente from './Clientes/EditarCliente';
import EditProfile from './EditProfile/EditProfile';
import ShowAnaliseObjeto from './AnalisesCandidatosObjetos/ShowAnaliseObjeto';
import CriarOrganizadora from './Organizadoras/CriarOrganizadora';


import Organizadoras from './Organizadoras/Organizadoras';
import IntegrationLogs from './IntegrationLogs/IntegrationLogs';
import EditarOrganizadora from './Organizadoras/EditarOrganizadora';
import Membros from './Membros/Membros';
import CriarMembro from './Membros/CriarMembro';
import EditarMembro from './Membros/EditarMembro';
import CriarAtribuicoesRedacao from './Demandas/CriarAtribuicoesRedacao';
import ShowDiagramacao from './Diagramacoes/ShowDiagramacao';
import CriarAvaliador from './Avaliador/CriarAvaliador';
import EditarAvaliador from './Avaliador/EditarAvaliador';
import CriarAvaliadorVinculado from './AvaliadoresVinculados/CriarAvaliadorVinculado';
import CriarEntrevista from './Entrevista/CriarEntrevista';
import EditarEntrevista from './Entrevista/EditarEntrevista';
import ShowEntrevista from './Entrevista/ShowEntrevista';
import ModulosSistema from './ModulosSistema/ModulosSistema';
import Redacao from './RedacoesProcesso/Redacao';
import { CircularProgress } from '@material-ui/core';
import Modulos from './Modulos/Modulos';
import CriarModulo from './Modulos/CriarModulo';
import EditarModulo from './Modulos/EditarModulo';
import ShowModulo from './Modulos/ShowModulo';
import Treinamentos from './Treinamentos/Treinamentos';
import CriarTreinamento from './Treinamentos/CriarTreinamento';
import VincularInstituicao from './Treinamentos/VincularInstituicao';
import EditarTreinamento from './Treinamentos/EditarTreinamento';
import ShowTreinamento from './Treinamentos/ShowTreinamento';

import DashboardTreinamento from './Treinamentos/DashboardTreinamento';

import AvaliarQuestoes from './Recursos/AvaliarQuestoes';
import ShowAvaliarQuestoes from './Recursos/ShowAvaliarQuestoes'
import Diagramacoes from './Diagramacoes/Diagramacoes';


const Home = (props) => {
    const toggled = useSelector(store => store.AppReducer.toggled)
    const collapsed = useSelector(store => store.AppReducer.collapsed)
    const user = useSelector(store => store.AppReducer.user);
    const token = useSelector(store => store.AppReducer.token);
    const adminAsUser = useSelector(store => store.AppReducer.adminAsUser);

    const dispatch = useDispatch();
    const [loading_home, setLoadingHome] = useState(true);
    const [image, setImage] = useState(true);

    // const [toggled, setToggled] = useState(false);
    const handleCollapsedChange = (checked) => {
        dispatch(mudarDados({ collapsed: checked }));

    };

    const GetRole = async () => {
        setLoadingHome(true);
        let response = await Request.Post(`faculdade/auth/get_user`)
        if (!response) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setLoadingHome(false);

            dispatch({ type: 'logout', payload: {} });
        }
        else if (response.message == "Unauthenticated.") {
            setLoadingHome(false);

            localStorage.removeItem('token'); localStorage.removeItem('user');
            dispatch({ type: 'logout', payload: {} });
            return;
        }
        else{
            dispatch({type:'login',payload:{token:token,user:response['user']}});
            setLoadingHome(false);
           
        }

    }

    const handleImageChange = (checked) => {
        setImage(checked);
    };

    const handleToggleSidebar = (value) => {
        // setToggled(value);
        dispatch(mudarDados({ toggled: value }));
    };



    useEffect(() => {
        const event = (e) => {
            if (window.innerWidth <= 768) {
                dispatch(mudarDados({ toggled: false, collapsed: false }));

            }
            else {

                dispatch(mudarDados({ toggled: true, collapsed: true }));

            }
        };
        window.addEventListener('resize', event)
        if (window.innerWidth <= 768) {
            dispatch(mudarDados({ toggled: false, collapsed: false }));
        }
        else {
            dispatch(mudarDados({ toggled: true, collapsed: true }));
        }
        GetRole();

        return () => {
            window.removeEventListener('resize', event);

            // Anything in here is fired on component unmount.
        }
    }, [])

    const guard = (module, action, Component) => routeProps => can(user, module, action)
        ? <Component {...routeProps} /> : <div className="alert alert-warning">Sem permissão para acessar este módulo.</div>;
    const guardUnrestricted = Component => routeProps => unrestricted(user)
        ? <Component {...routeProps} /> : <div className="alert alert-warning">Sem permissão para acessar este módulo.</div>;
    const guardMembers = Component => routeProps => canManageMembers(user)
        ? <Component {...routeProps} /> : <div className="alert alert-warning">Somente o proprietário da empresa pode gerenciar membros.</div>;
    const guardLinkedQuestionnaire = (action, Component) => routeProps =>
        can(user, 'processo_seletivo') && can(user, 'questionarios', action)
            ? <Component {...routeProps} /> : <div className="alert alert-warning">Sem permissão para acessar este módulo.</div>;

    const marginLeft = (toggled == false || window.innerWidth <= 768) ? 0 : (collapsed == false ? 270 : 80);
    console.log(props.match.url)
    return (
        <>
        {loading_home==true && <div className='d-flex align-items-center justify-content-center' style={{height:'100vh'}}>
            <CircularProgress/>
            </div>}
        {loading_home==false && <div className={`app ${toggled ? 'toggled' : ''}`}>
            <Aside
                image={image}
                collapsed={collapsed}
                toggled={toggled}

                handleToggleSidebar={handleToggleSidebar}
                handleCollapsedChange={handleCollapsedChange}

            />
            <Header
                image={image}
                toggled={toggled}
                collapsed={collapsed}
                handleToggleSidebar={handleToggleSidebar}
                handleCollapsedChange={handleCollapsedChange}
                handleImageChange={handleImageChange}
            />
            <div className="content-page" >
                <div className="content" style={{ marginLeft: marginLeft, transition: 'all 0.3s ', paddingBottom: 100, background: '#f8f8fa' }}>
                    <div className="container-fluid has-global-breadcrumb">
                        <GlobalBreadcrumb pathname={props.location.pathname} user={user} token={token} />
                        {(user.role == 'viwer') && <Switch>
                            <Route exact path={`${props.match.url}`} render={(props2) => <Diagramacoes {...props2} />} />
                            <Route exact path={`${props.match.url}edit_profile`} render={(props2) => <EditProfile {...props2} />} />
                        </Switch>}
                        {(user.role == 'region_admin' || user.role == 'faculdade') && <Switch>

                            <Route exact path={`${props.match.url}`} render={guard('processo_seletivo', 'view', Faculdades)} />
                            <Route exact path={`${props.match.url}instituicao/register`} render={guard('processo_seletivo', 'create', CriarFaculdade)} />
                            <Route exact path={`${props.match.url}instituicao/link/:id`} render={guard('processo_seletivo', 'view', VincularInstituicao)} />
                            <Route exact path={`${props.match.url}instituicao/dashboard/:faculdade_id`} render={guard('dashboard_resultados', 'view', DashboardInstituicao)} />

                            <Route exact path={`${props.match.url}instituicao/edit/:id`} render={guard('processo_seletivo', 'edit', EditarFaculdade)} />
                            <Route exact path={`${props.match.url}instituicao/show/:id`} render={guard('processo_seletivo', 'view', ShowFaculdade)} />
                            <Route exact path={`${props.match.url}minha-organizadora`} render={guard('portal_configuracoes','view',MinhaOrganizadora)} />
                            <Route exact path={`${props.match.url}minha-organizadora/editar`} render={guard('portal_configuracoes','edit',EditOrganization)} />
                            <Route exact path={`${props.match.url}instituicao/portal/:faculdade`} render={guard('portal_configuracoes', 'view', PortalHome)} />
                            <Route exact path={`${props.match.url}instituicao/portal/:faculdade/selecoes/:selection`} render={guard('portal_configuracoes', 'view', PortalSelection)} />
                            <Route exact path={`${props.match.url}instituicao/portal/:faculdade/inscricoes`} render={guard('portal_inscricoes', 'view', PortalApplications)} />
                            <Route exact path={`${props.match.url}instituicao/portal/:faculdade/inscricoes/:application`} render={guard('portal_inscricoes', 'view', PortalApplication)} />

                            <Route exact path={`${props.match.url}processos/register/:id`} render={guard('processo_seletivo', 'create', CriarProcesso)} />

                            <Route exact path={`${props.match.url}processos/edit/:id`} render={guard('processo_seletivo', 'edit', EditarProcesso)} />

                            <Route exact path={`${props.match.url}processos/show/:id`} render={guard('processo_seletivo', 'view', ShowProcesso)} />

                            <Route exact path={`${props.match.url}corretores/register/:id`} render={guard('corretores', 'create', CriarCorretor)} />
                            <Route exact path={`${props.match.url}corretores/edit/:id`} render={guard('corretores', 'edit', EditarCorretor)} />

                            <Route exact path={`${props.match.url}fiscais/register/:id`} render={guard('fiscais', 'create', CriarFiscal)} />
                            <Route exact path={`${props.match.url}fiscais/edit/:id`} render={guard('fiscais', 'edit', EditarFiscal)} />

                            <Route exact path={`${props.match.url}avaliadores/register/:id`} render={guard('avaliadores', 'create', CriarAvaliador)} />
                            <Route exact path={`${props.match.url}avaliadores/edit/:id`} render={guard('avaliadores', 'edit', EditarAvaliador)} />

                            <Route exact path={`${props.match.url}candidatos/register/:id`} render={guard('candidatos', 'create', CriarAluno)} />
                            <Route exact path={`${props.match.url}candidatos/edit/:id`} render={guard('candidatos', 'edit', EditarAluno)} />

                            {(user.role == 'region_admin' || (user.empresa == null || user.empresa.hide_questionario == false)) && <Route exact path={`${props.match.url}questionarios`} render={guard('questionarios', 'view', Questionarios)} />}
                            {(user.role == 'region_admin' || (user.empresa == null || user.empresa.hide_questionario == false)) && <Route exact path={`${props.match.url}questionarios/register`} render={guard('questionarios', 'create', CriarQuestionario)} />}
                            {(user.role == 'region_admin' || (user.empresa == null || user.empresa.hide_questionario == false)) && <Route exact path={`${props.match.url}questionarios/edit/:id`} render={guard('questionarios', 'edit', EditarQuestionario)} />}

                            <Route exact path={`${props.match.url}elaboradores`} render={guard('banca_questoes', 'view', Professores)} />
                            <Route exact path={`${props.match.url}elaboradores/register`} render={guard('banca_questoes', 'create', CriarProfessor)} />
                            <Route exact path={`${props.match.url}elaboradores/edit/:id`} render={guard('banca_questoes', 'edit', EditarProfessor)} />

                            <Route exact path={`${props.match.url}edit_profile`} render={(props2) => <EditProfile {...props2} />} />

                            <Route exact path={`${props.match.url}membros/`} render={guardMembers(Membros)} />
                            <Route exact path={`${props.match.url}membros/register/`} render={guardMembers(CriarMembro)} />
                            <Route exact path={`${props.match.url}membros/edit/:id`} render={guardMembers(EditarMembro)} />


                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}logs-integracao`} component={IntegrationLogs} />}
                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras`} render={(props2) => <Organizadoras {...props2} />} />}
                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/register`} render={(props2) => <CriarOrganizadora {...props2} />} />}
                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/edit/:id`} render={(props2) => <EditarOrganizadora {...props2} />} />}


                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/:id`} render={(props2) => <Clientes {...props2} />} />}
                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/register/:id`} render={(props2) => <CriarCliente {...props2} />} />}
                            {user.role == 'region_admin' && <Route exact path={`${props.match.url}organizadoras/membros/edit/:id`} render={(props2) => <EditarCliente {...props2} />} />}


                            <Route exact path={`${props.match.url}demandas`} render={guard('banca_questoes', 'view', Demandas)} />
                            <Route exact path={`${props.match.url}demandas/register`} render={guard('banca_questoes', 'create', CriarDemanda)} />
                            <Route exact path={`${props.match.url}demandas/edit/:id`} render={guard('banca_questoes', 'edit', EditarDemanda)} />
                            <Route exact path={`${props.match.url}demandas/show/:id`} render={guard('banca_questoes', 'view', ShowDemanda)} />
                            <Route exact path={`${props.match.url}atribuicoes/register/:id`} render={guard('banca_questoes', 'create', CriarAtribuicoes)} />
                            <Route exact path={`${props.match.url}atribuicoes/register_redacoes/:id`} render={guard('banca_questoes', 'create', CriarAtribuicoesRedacao)} />

                            <Route exact path={`${props.match.url}conteudos`} render={guardUnrestricted(Conteudos)} />
                            <Route exact path={`${props.match.url}conteudo/register`} render={guardUnrestricted(CriarConteudo)} />
                            <Route exact path={`${props.match.url}conteudo/edit/:id`} render={guardUnrestricted(EditarConteudo)} />
                            <Route exact path={`${props.match.url}conteudo/show/:id`} render={guardUnrestricted(ShowConteudo)} />

                            <Route exact path={`${props.match.url}conteudo/questao/register/:id`} render={guardUnrestricted(CriarQuestaoConteudo)} />
                            <Route exact path={`${props.match.url}conteudo/questao/edit/:id`} render={guardUnrestricted(EditarQuestaoConteudo)} />


                            <Route exact path={`${props.match.url}modulos`} render={guardUnrestricted(Modulos)} />
                            <Route exact path={`${props.match.url}modulo/register`} render={guardUnrestricted(CriarModulo)} />
                            <Route exact path={`${props.match.url}modulo/edit/:id`} render={guardUnrestricted(EditarModulo)} />
                            <Route exact path={`${props.match.url}modulo/show/:id`} render={guardUnrestricted(ShowModulo)} />


                            {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamentos`} render={guardUnrestricted(Treinamentos)} />}
                            {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamentos/register`} render={guardUnrestricted(CriarTreinamento)} />}
                            {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamento/edit/:id`} render={guardUnrestricted(EditarTreinamento)} />}
                            {user?.empresa?.plan?.training && <Route exact path={`${props.match.url}treinamento/show/:id`} render={guardUnrestricted(ShowTreinamento)} />}
                            {user?.empresa?.plan?.training &&  <Route exact path={`${props.match.url}treinamento/dashboard/:id`} render={guardUnrestricted(DashboardTreinamento)} />}

                            <Route exact path={`${props.match.url}redacoes/show/:id`} render={guard('redacoes', 'view', ShowRedacoesProcesso)} />

                            <Route exact path={`${props.match.url}atribuicoes/show/:demanda_id`} render={guard('banca_questoes', 'view', QuestoesDemanda)} />


                            <Route exact path={`${props.match.url}recursos`} render={guard('banca_questoes', 'view', Recursos)} />
                            <Route exact path={`${props.match.url}recursos/register`} render={guard('banca_questoes', 'create', CriarRecurso)} />
                            <Route exact path={`${props.match.url}recursos/edit/:id`} render={guard('banca_questoes', 'edit', EditarRecurso)} />
                            <Route exact path={`${props.match.url}recursos/show/:id`} render={guard('banca_questoes', 'view', ShowRecurso)} />
                           
                           
                            <Route exact path={`${props.match.url}avaliar-questoes`} render={guard('banca_questoes', 'view', AvaliarQuestoes)} />
                            <Route exact path={`${props.match.url}avaliar-questoes/show/:id`} render={guard('banca_questoes', 'view', ShowAvaliarQuestoes)} />




                            <Route exact path={`${props.match.url}disciplinas`} render={guard('disciplinas_questoes', 'view', CategoriasQuestoes)} />
                            <Route exact path={`${props.match.url}disciplinas/register`} render={guard('disciplinas_questoes', 'create', CriarCategoria)} />
                            <Route exact path={`${props.match.url}disciplinas/edit/:id`} render={guard('disciplinas_questoes', 'edit', EditarCategoria)} />

                            <Route exact path={`${props.match.url}disciplinas/show/:id`} render={guard('disciplinas_questoes', 'view', Questoes)} />
                            <Route exact path={`${props.match.url}questoes/register/:id`} render={guard('disciplinas_questoes', 'create', CriarQuestao)} />
                            <Route exact path={`${props.match.url}questoes/edit/:id`} render={guard('disciplinas_questoes', 'edit', EditarQuestao)} />
                            
                            {user?.empresa?.plan?.question_ia && <Route exact path={`${props.match.url}questoes/chatbot/:id`} render={guard('disciplinas_questoes', 'view', ChatBotQuestao)} />}


                            <Route exact path={`${props.match.url}banca-questoes`} render={guard('disciplinas_questoes', 'view', BancaQuestoes)} />


                            <Route exact path={`${props.match.url}redacoes/register/:id`} render={guard('redacoes', 'create', CriarRedacao)} />
                            <Route exact path={`${props.match.url}redacoes/edit/:id`} render={guard('redacoes', 'edit', EditarRedacao)} />
                           
                            <Route exact path={`${props.match.url}provas/register/:id`} render={guard('provas', 'create', CriarProva)} />
                            <Route exact path={`${props.match.url}provas/register_existing/:id`} render={guard('provas', 'create', CriarProvaExistente)} />


                            <Route exact path={`${props.match.url}provas/edit/:id`} render={guard('provas', 'edit', EditarProva)} />

                            <Route exact path={`${props.match.url}entrevistas/register/:id`} render={guard('entrevistas', 'create', CriarEntrevista)} />
                            <Route exact path={`${props.match.url}entrevistas/edit/:id`} render={guard('entrevistas', 'edit', EditarEntrevista)} />
                            <Route exact path={`${props.match.url}entrevistas/show/:id`} render={guard('entrevistas', 'view', ShowEntrevista)} />



                            <Route exact path={`${props.match.url}diagramacoes/register/:id`} render={guard('provas', 'create', CriarDiagramacao)} />
                            <Route exact path={`${props.match.url}diagramacoes/edit/:id`} render={guard('provas', 'edit', EditarDiagramacao)} />

                            <Route exact path={`${props.match.url}questionarios_vinculados/register/:id`} render={guardLinkedQuestionnaire('create', CriarQuestionarioVinculado)} />
                            <Route exact path={`${props.match.url}questionarios_vinculados/show/:processo_id/:questionario_id`} render={guardLinkedQuestionnaire('view', ShowQuestionarioProcesso)} />

                            <Route exact path={`${props.match.url}avaliadores_vinculados/show/:id/:processo_id`} render={guard('avaliadores', 'view', ShowAvaliador)} />

                            <Route exact path={`${props.match.url}avaliadores_vinculados/register/:id`} render={guard('avaliadores', 'create', CriarAvaliadorVinculado)} />

                            <Route exact path={`${props.match.url}fiscais_vinculados/show/:id/:processo_id`} render={guard('fiscais', 'view', ShowFiscal)} />

                            <Route exact path={`${props.match.url}candidatos_vinculados/show/:id/:processo_id`} render={guard('candidatos', 'view', ShowCandidato)} />

                            <Route exact path={`${props.match.url}candidatos_vinculados/register/:id`} render={guard('candidatos', 'create', CriarCandidatoVinculado)} />

                            <Route exact path={`${props.match.url}fiscais_vinculados/register/:id`} render={guard('fiscais', 'create', CriarFiscalVinculado)} />
                            <Route exact path={`${props.match.url}corretores_vinculados/register/:id`} render={guard('corretores', 'create', CriarCorretorVinculado)} />

                            <Route exact path={`${props.match.url}salas/show/:id`} render={routeProps => canSeeRooms(user) ? <ShowSala {...routeProps} /> : <div className="alert alert-warning">Sem permissão para acessar este módulo.</div>} />



                            <Route exact path={`${props.match.url}provas/show/:id`} render={guard('provas', 'view', ShowProvasProcesso)} />
                            <Route exact path={`${props.match.url}diagramacoes/show/:id`} render={guard('provas', 'view', ShowDiagramacao)} />

                            <Route exact path={`${props.match.url}system`} render={guardUnrestricted(ModulosSistema)} />


                            <Route exact path={`${props.match.url}candidatos_errors/edit/:id`} render={guard('candidatos', 'edit', EditarCandidatoConflito)} />


                            <Route exact path={`${props.match.url}processos/show_analises/:id`} render={guard('candidatos', 'view', ShowAnalise)} />
                            <Route exact path={`${props.match.url}processos/show_analises_objetos/:id/:processo_id`} render={guard('candidatos', 'view', ShowAnaliseObjeto)} />


                        </Switch>}
                    </div>
                </div>
            </div>
            
        </div>}
        </>

    );
}

export default Home;
